import { COMMUNITY_BASE_URL } from '../../constants/endpoint'
import { BlogItem } from '../models/communityBlog.model'
import { ICommunityNewsSearchResults } from '../models/communityNews.model'
import { IAntiforgeryToken } from '../models/general.model'
import { getAntiforgeryToken } from './general.service'

export async function getBlogPost(blogPageId: string): Promise<BlogItem> {
  let response = await fetch(`${COMMUNITY_BASE_URL}/blogs/getpost?blogPageId=${blogPageId}`)

  const jsonResult = await response.json()
  return <BlogItem>jsonResult
}

export async function getBlogPosts(pageIndex: number, communityBlogListingPageId: string): Promise<any> {
  let response = await fetch(
    `${COMMUNITY_BASE_URL}/blogs/getposts?blogListingPageId=${communityBlogListingPageId}&pageIndex=${pageIndex}`,
  )

  const jsonResults = await response.json()
  return <ICommunityNewsSearchResults>jsonResults
}

export async function createBlogPost(blogFormData: BlogItem): Promise<any> {
  const { csrfToken }: IAntiforgeryToken = await getAntiforgeryToken()

  const formData = new FormData()
  formData.append('BlogListingPageId', blogFormData.blogListingPageId.toString())
  formData.append('Heading', blogFormData.heading)
  formData.append('Preamble', blogFormData.preamble)
  formData.append('Body', blogFormData.body)

  if (blogFormData.topImage) formData.append('TopImage', blogFormData.topImage[0])
  if (blogFormData.attachment) formData.append('Attachment', blogFormData.attachment[0])
  if (blogFormData.communityBlogPageId)
    formData.append('CommunityBlogPageId', blogFormData.communityBlogPageId.toString())

  let response = await fetch(`${COMMUNITY_BASE_URL}/blogs/createpost`, {
    method: 'POST',
    headers: {
      'X-CSRF-TOKEN': csrfToken,
    },
    body: formData,
  })

  return response.ok
}

export async function updateBlogPost(blogFormData: BlogItem): Promise<any> {
  const { csrfToken }: IAntiforgeryToken = await getAntiforgeryToken()

  const formData = new FormData()
  formData.append('BlogListingPageId', blogFormData.blogListingPageId.toString())
  formData.append('Heading', blogFormData.heading)
  formData.append('Preamble', blogFormData.preamble)
  formData.append('Body', blogFormData.body)

  if (blogFormData.topImage) formData.append('TopImage', blogFormData.topImage[0])
  if (blogFormData.attachment) formData.append('Attachment', blogFormData.attachment[0])
  if (blogFormData.communityBlogPageId)
    formData.append('CommunityBlogPageId', blogFormData.communityBlogPageId.toString())

  let response = await fetch(`${COMMUNITY_BASE_URL}/blogs/updatepost?blogPageId=${blogFormData.communityBlogPageId}`, {
    method: 'PUT',
    headers: {
      'X-CSRF-TOKEN': csrfToken,
    },
    body: formData,
  })

  return response.ok
}
